import React, {
  createContext,
  useCallback,
  useContext,
  useMemo,
  useState,
} from "react"
import PropTypes from "prop-types"
import { clearOnboardingSession } from "helpers/onboarding_api_helper"

const defaultFormValues = {
  name: "",
  domain: "",
  slug: "",
  contactEmail: "",
  adminEmail: "",
}

const defaultPaymentValues = {
  cardholderName: "",
  cardNumber: "",
  expiry: "",
  cvv: "",
}

const OnboardingContext = createContext(null)

export const OnboardingProvider = ({ children }) => {
  const [formDraft, setFormDraft] = useState(defaultFormValues)
  const [selectedPlanId, setSelectedPlanId] = useState("")
  const [planSnapshot, setPlanSnapshot] = useState(null)
  const [paymentDraft, setPaymentDraft] = useState(defaultPaymentValues)
  const [registeredSnapshot, setRegisteredSnapshot] = useState(null)

  const resetFlow = useCallback(() => {
    setFormDraft(defaultFormValues)
    setSelectedPlanId("")
    setPlanSnapshot(null)
    setPaymentDraft(defaultPaymentValues)
    setRegisteredSnapshot(null)
    clearOnboardingSession()
  }, [])

  const value = useMemo(
    () => ({
      formDraft,
      setFormDraft,
      selectedPlanId,
      setSelectedPlanId,
      planSnapshot,
      setPlanSnapshot,
      paymentDraft,
      setPaymentDraft,
      registeredSnapshot,
      setRegisteredSnapshot,
      resetFlow,
    }),
    [
      formDraft,
      selectedPlanId,
      planSnapshot,
      paymentDraft,
      registeredSnapshot,
      resetFlow,
    ]
  )

  return (
    <OnboardingContext.Provider value={value}>{children}</OnboardingContext.Provider>
  )
}

OnboardingProvider.propTypes = {
  children: PropTypes.node,
}

export const useOnboarding = () => {
  const ctx = useContext(OnboardingContext)
  if (!ctx) {
    throw new Error("useOnboarding must be used within OnboardingProvider")
  }
  return ctx
}

export { defaultFormValues, defaultPaymentValues }
